import React from 'react';
import { PrismicRichText } from '@prismicio/react';
import { createClient } from '@prismicio/client';
import ReceipesComponent from './ReceipesComponent';

/**
 * @typedef {import("@prismicio/client").Content.LatestRecipesSlice} LatestRecipesSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<LatestRecipesSlice>} LatestRecipesProps
 * @param { LatestRecipesProps }
 */
const LatestRecipes = ({ slice, context }) => {
  const { pages, pageType } = context || {};
  return <ReceipesComponent pages={pages} pageType={pageType} />;
};

export default LatestRecipes;
